<template>
  <div class="pc-search">
    <el-form
      class="pc-search-main-formOne "
      :model="keywordData"
      :inline="true"
    >
      <el-form-item label="标题" class="realName">
        <el-input
          v-model="keywordData.title"
          placeholder="请输入标题名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="ID" class="topTwo">
        <el-input
          v-model="keywordData.id"
          placeholder="请输入ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="标签" class="topTwo">
        <el-cascader :options="options"  @change="saveTag($event)" clearable></el-cascader>
      </el-form-item>

      <el-form-item label="创建时间" class="createTime">
        <el-date-picker
          v-model="keywordData.createTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="设计者" class="topTwo">
        <!-- <el-input v-model="keywordData.wupenLegend"></el-input> -->
        <el-select
          v-model="keywordData.wupenLegend"
          @change="saveTeacher($event)"
          clearable
          placeholder="选择设计者"
        >
         <el-option
                v-for="(item, index) in teacherList"
                :key="index"
                :value="item.name ? item.name : item.englishName"
                :label="item.name ? item.name : item.englishName"
                :disabled="item.disabled"
              >
              </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="奖项" placeholder="奖项" class="topTwo">
        <el-select v-model="keywordData.awardsName" clearable @change="saveAwards($event)" placeholder="选择奖项">
          <el-option v-for="(item,index) in awardsList" :key="index" :label="item.name?item.name:item.englishName" :value="item.name?item.name:item.englishName"></el-option>
        </el-select>
      </el-form-item>
       <button class="pc-search-clickBtn" @click.prevent="search">筛选</button>
    </el-form>
      
  </div>
</template>



<script>
import {getPersons } from "../bestPracticeList.gql";
import {getTagTypes} from '../../../template/graphql/typeTag.gql'
import {getPracticeAwards} from '../awards.gql'
export default {
  data() {
    return {
      keywordData: {
        keywordTag:null,
        keywordTeacher:null,
        keywordAward:null,
        realName: null,
        tag: [],
        title:null,
        id:null,
        wupenLegend: null,
        awardsName:null,
        keywords:'',
        createTime:[],
      },
      // 标签接口
      typeTagArgs: {
        skip: 0,
        type: "BP",
        order:'+createTime'
      },
      // 奖项接口后端需要的接口
      practiceAwardsArgs: {
        skip: 0,
        status: -1,
        take: 0,
        total: 0,
        cell: 0
      },
    
      // 测试标签字段
       options: [],
       // 授课老师数组
      teacherList:[],
      // 奖项列表
      awardsList:[],
    };
  },
  mounted() {
    // 获取奖项
    this.getPracticeAwards()
    // 获取设计师
    this.getTeacherList()
    // 获取标签
    this.getTagTypes()
  },
  methods: {
    // 奖项下拉列表
    getPracticeAwards() {
      this.$global
        .GraphqlQuery(this, getPracticeAwards, this.practiceAwardsArgs)
        .then(res => {
          this.practiceAwardsArgs.total = res.total;
          this.awardsList = res.data;
        });
    },
    // 渲染标签
    getTagTypes(){
          this.$global
        .GraphqlQuery(this, getTagTypes, this.typeTagArgs)
        .then(res => {
          this.options=[]
          for(let i=0;res.data.length>i;i++){
            this.options.push(res.data[i])
            this.options[i].value=this.options[i].name
            this.options[i].label=this.options[i].name
            if(res.data[i].tags.length>0){
              this.options[i].children=res.data[i].tags
              for(let t=0;this.options[i].children.length>t;t++){
                this.options[i].children[t].label=this.options[i].children[t].name
                this.options[i].children[t].value=this.options[i].children[t].name
              }
            }
          }
          // this.options = res.data;
        });
    },
      // 获取授课教师
     getTeacherList(){
      this.$global.GraphqlQuery(this,getPersons,{
        status:1,
        order:'+englishName',
      }).then((res) => {
        this.teacherList = res.data
      })
    },

    // 保存设计者
    saveTeacher(ids){
      this.keywordData.keywordTeacher= ids
    },
    // 保存
    saveAwards(ids){
      this.keywordData.keywordAward= ids
    },
    // 保存标签
    saveTag(tagData){
       this.keywordData.keywordTag = tagData[1] ? tagData[1] : null
    },
    search() {
      
      let keyword = '';
      keyword = this.keywordData.keywordTeacher ? (keyword + this.keywordData.keywordTeacher +','):keyword
      keyword = this.keywordData.keywordTag ? (keyword + this.keywordData.keywordTag +','):keyword
      keyword = this.keywordData.keywordAward ? (keyword + this.keywordData.keywordAward +','):keyword
      this.keywordData.keywords = keyword.substr(0,keyword.length-1)
      this.$emit("search", this.keywordData);
      
      // this.keywordData.keywords=''
    }
  }
};
</script>



<style lang="scss" scoped>
.pc-search {
  position: relative;
  .pc-search-main-formOne {
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .el-form-item {
    margin-bottom: 20px !important;
  }

  // 预设两行
  /deep/ .el-form-item__label {
    font-family: $chinese;
    font-size: 14px;
    font-weight: bold;
    color: $mainTitle;
    width: 70px;
  }

  // 第一行 名称
  /deep/ .realName, /deep/ .createTime {
    width: 42%;
    .el-form-item__content {
      width: 80%;
      .el-input__inner {
        width: 100%;
      }
    }
  }
  // 第一行 标签
  /deep/ .topTwo .el-input__inner {
    width: 240px;
  } 

  .pc-search-clickBtn {
    position: absolute;
    right: 0;
    bottom: 20px;
    width: 90px;
    height: 40px;
    background: $blueBtn;
    border-radius: 4px;
    outline: none;
    border: none;
    font-family: $chinese;
    font-size: 14px;
    color: white;
    cursor: pointer;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/admin/bestPractice/components/BestPracticeSearch.vue